
<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Committee',

    metaInfo: { title: 'Committees' },

    extends: View,

    mixins: [
      LoadSections([
        'committee',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'committee',
      },
    },
  }
</script>
